import axios from "axios";
import { useEffect, useState } from "react";
import { HEADERS_API } from "../NuevaGuia";
import { ValidarNum, ValidarNumLtr } from "../../shared/Regex";
import { NMEntidadEmisora } from "../../shared/Denominaciones";

export default function FormularioVehiculo({funcionAgregar, funcionCancelar}){
    //#region HOOKS STATE
    // =========================================================================================
    
    const[placa, setPlaca] = useState("");
    const[entidadEmisora, setEntidadEmisora] = useState("");
    const[codigoEntidad, setCodigoEntidad] = useState("");
    const[autorizacion, setAutorizacion] = useState("");
    const[descripcion, setDescripcion] = useState("");

    // Estados de validación
    const[datosCompletos, setDatosCompletos] = useState(true);
    //#endregion

    // Estados de lista
    const[selectEntidades, setSelectEntidades] = useState(<></>);

    //#region HOOKS EFFECT
    // =========================================================================================
    useEffect(()=>{
        obtenerListaEntidades();
    },[]);

    useEffect(()=>{
        try{
            if(placa.length != 6 || entidadEmisora == "" || autorizacion == "" || descripcion == ""){
                throw new Error();
            }
            HandlerDatosCompletos(false);
        }catch(error){
            HandlerDatosCompletos(true);
        }
    },[placa, entidadEmisora, autorizacion, descripcion]);

    useEffect(()=>{
        codigoEntidad != "" && HandlerEntidadEmisora(NMEntidadEmisora(codigoEntidad));
    },[codigoEntidad])
    //#endregion

    //#region  HANDLERS
    // =========================================================================================
    const HandlerPlaca = (valor) => {
        if(ValidarNumLtr(valor) || valor == ""){
            setPlaca(valor.toUpperCase());
        }
    }
    const HandlerAutorizacion = (valor) => {
        if(ValidarNumLtr(valor) || valor == ""){
            setAutorizacion(valor.toUpperCase());
        }
    }
    const HandlerDescripcion = (valor) => {
        if(ValidarNumLtr(valor) || valor == ""){
            setDescripcion(valor.toUpperCase());
        }
    }
    const HandlerEntidadEmisora = (valor) => setEntidadEmisora(valor);
    const HandlerCodigoEntidad = (valor) => setCodigoEntidad(valor);
    const HandlerDatosCompletos = (valor) => setDatosCompletos(valor);
    
    const HandlerSelectEntidades = (lista) => {
        setSelectEntidades(<>{lista.map((item, index)=>(
            <option key={index} value={item.codigoCatalogo} >{item.descEntidad}</option>
        ))}</>)
    }
    //#endregion

    //#region FUNCIONES
    // =========================================================================================

    // FUNCIONES ASÍNCRONAS
    const registrarVehiculo = async () => {
        try{
            let response = await axios.post(URL_INSERTAR_VEHICULO,{
                codigoUsuario: "",
                placa: placa,
                entidadEmisora: entidadEmisora,
                autorizacion: autorizacion,
                descripcion: descripcion,
                codigoEntidad: codigoEntidad
            },{
                headers:HEADERS_API
            }).catch(error=>{
                throw new Error(error.message);
            });
            // console.log(response.data);
        }catch(error){
            console.log(error);
        }
    }
    const obtenerListaEntidades = async () => {
        try{
            let response = await axios.get(URL_ENTIDADES_EMISORAS,{
                headers: HEADERS_API
            }).catch(error =>{
                throw new Error(error.message);
            });

            if(response.data.mensajeError != null){
                throw new Error(response.data.mensajeError);
            }

            HandlerSelectEntidades(response.data.lista);
            HandlerCodigoEntidad("06");
        }catch(error){
            console.log(error.message);
        }
    }

    const ejecutarFuncion = async () => {
        funcionAgregar(placa, entidadEmisora, codigoEntidad, autorizacion, descripcion);
        await registrarVehiculo();
        funcionCancelar();
    }
    //#endregion

    //#region CONTENIDO
    // =========================================================================================
    return (
    <div id="modal-actor" className="d-flex justify-content-center align-items-center">
        <div id="formulario-registro">
            <div className="bg-primary text-white p-2 fs-4">
                NUEVO VEHÍCULO
            </div>
            <div className="p-2">
                <div className="row">
                    <div className="pb-3 col-12">
                        <label htmlFor="placa-vehiculo" className="col-form-label fw-semibold">Placa</label>
                        <input onChange={e => HandlerPlaca(e.target.value)} value={placa} maxLength={10} id="placa-vehiculo" type="text" className="form-control" autoComplete="off" />                        
                    </div>
                    <div className="pb-3 col-12">
                        <label htmlFor="entidad-vehiculo" className="col-form-label fw-semibold">Entidad Emisora</label>
                        <select onChange={e => HandlerCodigoEntidad(e.target.value)} value={codigoEntidad} id="entidad-vehiculo" type="select" className="form-select f-actor-texto" >
                            {selectEntidades}                          
                        </select>
                    </div>
                    <div className="pb-3 col-12">
                        <label htmlFor="autorizacion-vehiculo" className="col-form-label fw-semibold">N° Autorización Especial</label>
                        <input onChange={e => HandlerAutorizacion(e.target.value)} value={autorizacion} maxLength={15} id="autorizacion-vehiculo" type="text" className="form-control" autoComplete="off" />                        
                    </div>
                    <div className="pb-3 col-12">
                        <label htmlFor="descripcion-vehiculo" className="col-form-label fw-semibold">Descripción del vehículo</label>
                        <input onChange={e => HandlerDescripcion(e.target.value)} value={descripcion} maxLength={150} id="descripcion-vehiculo" type="text" className="form-control" autoComplete="off" />                        
                    </div>
                    <div className="p-2 d-flex justify-content-around">
                        <button onClick={funcionCancelar} className="btn btn-secondary">Cancelar</button>
                        <button onClick={ejecutarFuncion} disabled={datosCompletos} className="btn btn-primary">Aceptar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
    //#endregion
}
//#region CONSTANTES
const URL_INSERTAR_VEHICULO = process.env.REACT_APP_URL_INSERTAR_VEHICULO;
const URL_ENTIDADES_EMISORAS = process.env.REACT_APP_URL_ENTIDADES_EMISORAS;
//#endregion